import React from 'react';
import { makeStyles } from '@fluentui/react-components';
import { customColors, AlwaysOnScrollBarStyles } from '../../../styles';
import AgentOverviewContent from './partials/AgentOverviewContent';
import { NexusAgent } from '../../../domain/agents/models/Agent';
import AgentOverviewHeader from './partials/AgentOverviewHeader';

const useStyles = makeStyles({
    root: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: '25px',
        paddingTop: '30px',
        paddingBottom: '50px',
        backgroundColor: customColors.protivitiOffWhite,
        overflowY: 'auto',
        boxSizing: 'border-box',
        ...AlwaysOnScrollBarStyles,
    },
});

interface AgentOverviewTabProps {
    agent: NexusAgent | null;
}

const AgentOverviewTab: React.FC<AgentOverviewTabProps> = ({ agent }) => {
    const styles = useStyles();

    return (
        <div className={styles.root}>
            <AgentOverviewHeader agent={agent} />
            <AgentOverviewContent agent={agent} />
        </div>
    );
};

export default AgentOverviewTab;
